import React from 'react';
import classnames from 'classnames';
import {
  STOCK_STATUS_AVAILABLE,
  STOCK_STATUS_NOT_AVAILABLE,
} from 'types/ProductPageV2/ProductsStocks';

import styles from './ProductSelectItem.module.scss';

/**
 * Product page of website. Contains details product data.
 */
function ProductSelectItem({
  label,
  state,
  stateLabel,
  anotherMessage,
  extraStyle,
}: {
  label: string;
  state?: number;
  stateLabel?: string;
  anotherMessage?: string;
  extraStyle?: ExtraStyleType;
}): JSX.Element {
  /**
   * Add available state class
   *
   * @param {number} state
   */
  const addAvailableStateClass = (state: number) => {
    return {
      [styles.available]: state === STOCK_STATUS_AVAILABLE,
      [styles.notAvailable]: state === STOCK_STATUS_NOT_AVAILABLE,
    };
  };

  return (
    <>
      <div className={styles.container}>
        {anotherMessage}
        <span
          className={classnames(styles.label, {
            [`${extraStyle?.label}`]: extraStyle?.label,
          })}
        >
          {label}
        </span>
        {state !== undefined && (
          <span
            className={classnames(styles.state, addAvailableStateClass(state))}
          >
            {stateLabel}
          </span>
        )}
      </div>
    </>
  );
}

export default ProductSelectItem;

export type ExtraStyleType = {
  label: string;
};
